var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AppBar, Box, Button, Container, Drawer, IconButton, Stack, useMediaQuery } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import Logo from '../../authenticated/shared/logo/Logo';
import Navigations from './Navigations';
import MobileSidebar from './MobileSidebar';
import { IconMenu2 } from '@tabler/icons-react';
import { useAuthStatus } from "../../../lib/allauth/allauth-hooks";
import Profile from "../../authenticated/vertical/header/Profile";
import { appUrls } from "../../../urls";
var Header = function (_a) {
    var narrowHeader = _a.narrowHeader, onHeightChange = _a.onHeightChange;
    var AppBarStyled = styled(AppBar, {
        shouldForwardProp: function (prop) { return prop !== 'scrolled'; },
    })(function (_a) {
        var _b;
        var theme = _a.theme, scrolled = _a.scrolled;
        return (_b = {
                justifyContent: 'center',
                backgroundColor: theme.palette.primary.light,
                transition: 'all 0.3s ease',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                zIndex: theme.zIndex.appBar
            },
            _b[theme.breakpoints.up('lg')] = {
                minHeight: scrolled ? '60px' : (narrowHeader ? '70px' : '100px'),
            },
            _b);
    });
    var _b = React.useState(false), scrolled = _b[0], setScrolled = _b[1];
    React.useEffect(function () {
        var handleScroll = function () {
            var shouldBeScrolled = window.scrollY > 50;
            setScrolled(function (prev) {
                if (prev !== shouldBeScrolled) {
                    return shouldBeScrolled;
                }
                return prev; // no re-render if no change
            });
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    var headerRef = React.useRef(null);
    var _c = React.useState(0), headerHeight = _c[0], setHeaderHeight = _c[1];
    React.useEffect(function () {
        var handleResize = function () {
            if (headerRef.current) {
                var height = headerRef.current.offsetHeight;
                setHeaderHeight(height);
                if (onHeightChange) {
                    onHeightChange(height); // <- notify parent of the new height
                }
            }
        };
        handleResize(); // Initial call
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    React.useEffect(function () {
        if (headerRef.current && onHeightChange) {
            onHeightChange(headerRef.current.offsetHeight);
        }
    }, [scrolled, onHeightChange]);
    var ToolbarStyled = styled(Toolbar, {
        shouldForwardProp: function (prop) { return prop !== 'scrolled'; },
    })(function (_a) {
        var theme = _a.theme, scrolled = _a.scrolled;
        return ({
            width: '100%',
            paddingLeft: scrolled ? theme.spacing(1) : '0 !important',
            paddingRight: scrolled ? theme.spacing(1) : '0 !important',
            justifyContent: 'space-between',
            color: theme.palette.text.secondary,
            transition: 'all 0.5s ease',
            minHeight: scrolled ? '60px' : 'inherit',
        });
    });
    var _d = useAuthStatus(), _ = _d[0], authInfo = _d[1];
    //   sidebar
    var lgUp = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var lgDown = useMediaQuery(function (theme) { return theme.breakpoints.down('lg'); });
    var _e = React.useState(false), open = _e[0], setOpen = _e[1];
    var handleDrawerOpen = function () {
        setOpen(true);
    };
    var toggleDrawer = function (newOpen) { return function () {
        setOpen(newOpen);
    }; };
    return (_jsxs(AppBarStyled, __assign({ ref: headerRef, position: "sticky", elevation: 0, scrolled: scrolled }, { children: [!narrowHeader /* && <HeaderAlert/> */, _jsx(Container, __assign({ sx: {
                    maxWidth: '1400px !important',
                } }, { children: _jsxs(ToolbarStyled, __assign({ scrolled: scrolled }, { children: [_jsx(Box, __assign({ sx: {
                                transform: scrolled ? 'scale(0.9)' : 'scale(1)',
                                transition: 'transform 0.3s ease',
                                display: 'inline-block', // ensure scale affects only the logo
                            } }, { children: _jsx(Logo, {}) })), lgDown ? (_jsx(IconButton, __assign({ color: "inherit", "aria-label": "menu", onClick: handleDrawerOpen }, { children: _jsx(IconMenu2, { size: "20" }) }))) : null, lgUp ? (_jsxs(_Fragment, { children: [_jsx(Stack, __assign({ spacing: 1, direction: "row", alignItems: "center" }, { children: _jsx(Navigations, {}) })), authInfo && authInfo.isAuthenticated ? (_jsx(Profile, { includeDashboardLink: true })) : (_jsxs(Stack, __assign({ direction: "row", spacing: 1, alignItems: "center" }, { children: [_jsx(Box, __assign({ component: "a", href: appUrls.auth.LOGIN, sx: { textDecoration: 'none', color: 'primary.main', display: 'inline-block', padding: 1, paddingRight: 2, fontWeight: 500, fontSize: 15 } }, { children: "Sign in" })), _jsx(Button, __assign({ color: "primary", variant: "contained", sx: { fontWeight: 500, fontSize: 15 }, href: appUrls.auth.REGISTER }, { children: "Sign up" }))] })))] })) : null] })) })), _jsx(Drawer, __assign({ anchor: "left", open: open, variant: "temporary", onClose: toggleDrawer(false), PaperProps: {
                    sx: {
                        width: 270,
                        border: '0 !important',
                        boxShadow: function (theme) { return theme.shadows[8]; },
                    },
                } }, { children: _jsx(MobileSidebar, {}) }))] })));
};
export default Header;
